// Raw SharePoint/Azure AD connection errors (MSAL token failures, Graph API
// failures) are full technical dumps meant for developers — AADSTS codes,
// Trace ID, Correlation ID, timestamps. Showing that verbatim to an org
// admin is unprofessional and unhelpful. This maps the common cases to a
// short, actionable, translated message and falls back to a generic one for
// anything unrecognized — the raw text is never shown in the UI, only ever
// logged/stored server-side for support engineers who need it.
export function formatSharePointError(rawMessage, t) {
  const msg = String(rawMessage || '');

  // Only step in for messages that actually look like a raw technical dump
  // (MSAL/Graph error text) — other backend messages are already short and
  // admin-facing (e.g. "SharePoint connection already exists"), so leave
  // those untouched instead of flattening them all to one generic line.
  const looksTechnical = /AADSTS|Trace ID|Correlation ID|Failed to acquire token|Failed to resolve site|Failed to list drives|Failed to download|graph\.microsoft\.com/i.test(msg);
  if (!looksTechnical) return msg;

  if (/AADSTS7000215|AADSTS7000222|invalid client secret|expired.*secret/i.test(msg)) {
    return t('manageOrganization.spErrorInvalidSecret');
  }
  if (/AADSTS700016|application.*not found in.*tenant/i.test(msg)) {
    return t('manageOrganization.spErrorAppNotFound');
  }
  if (/AADSTS90002|tenant.*not found/i.test(msg)) {
    return t('manageOrganization.spErrorTenantNotFound');
  }
  if (/AADSTS/i.test(msg) || /failed to acquire token/i.test(msg)) {
    return t('manageOrganization.spErrorAuthFailed');
  }
  if (/403|forbidden|insufficient privileges|access.*denied/i.test(msg)) {
    return t('manageOrganization.spErrorPermissionDenied');
  }
  if (/404|not found/i.test(msg)) {
    return t('manageOrganization.spErrorSiteNotFound');
  }
  return t('manageOrganization.spErrorGeneric');
}
